<div mat-dialog-content>
    <div fxLayout="column">
        <div fxLayout="row" fxLayout.sm="column">
            <label>Source:</label><mat-label>{{audit.source}}</mat-label>
        </div>
        <div fxLayout="row" fxLayout.sm="column">
            <label>User Name:</label><mat-label>{{audit.userName}}</mat-label>
        </div>
        <br/>
        <div fxLayout="row" fxLayout.sm="column">
            <label>Confirmed:</label><mat-label>{{ audit.isConfirmed ? 'Yes' : 'No' }}</mat-label>
        </div>
        <br/>
        <div id="" style="overflow:auto; height:650px; width:500px; ">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="audit-tree">
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                    <li class="mat-tree-node">
                        <button mat-icon-button disabled></button>
                        {{node.displayText}}
                    </li>
                </mat-tree-node>
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                    <li>
                        <div class="mat-tree-node">
                            <button mat-icon-button matTreeNodeToggle
                                    [attr.aria-label]="'toggle ' + node.name">
                                <mat-icon class="mat-icon-rtl-mirror">
                                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                </mat-icon>
                            </button>
                            {{node.displayText}}
                        </div>
                        <ul [class.audit-tree-invisible]="!treeControl.isExpanded(node)">
                            <ng-container matTreeNodeOutlet></ng-container>
                        </ul>
                    </li>
                </mat-nested-tree-node>
            </mat-tree>
        </div>

        <div mat-dialog-actions>
            <button mat-button (click)="onOkClick()">Ok</button>
        </div>
    </div>
</div>
